module.exports = __webpack_public_path__ + "officialStatic/img/case-klgs.7734726.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/partner/case-klgs.jpg
// module id = LuSu
// module chunks = 0